import React, { useState } from 'react';
import { AnchorLink } from "gatsby-plugin-anchor-links";

export interface IPrefs {
    tags: string[];
    url?: string;
}

const Taglist = ({ tags, url }: IPrefs) => {

    const slugs = require('github-slugger')();
    // gap-x-3 gap-y-1
    return (
        <div className="tags text-xs uppercase flex mt-1 flex-wrap">
            {
                tags.map((tag: string, key: number) => (
                    <AnchorLink key={key} to={url ? url + '#'+slugs.slug(tag) : '#'+slugs.slug(tag)} className="inline-block mr-3">{tag}</AnchorLink>
                    /*
                <React.Fragment key={key}>
                    {key > 0 ? <span className="px-4">|</span> : ""}
                    <AnchorLink to={url ? url + '#'+slugs.slug(tag) : '#'+slugs.slug(tag)} className="inline-block">{tag}</AnchorLink>
                </React.Fragment>*/
                ))
            }
        </div>
    );
}

export default Taglist;